import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";

import cnt from "../services/definedConstant";
import { BOM } from "../services/definedMethod";
import { fetchSession, normalizeAuthUser } from "../services/authSession";

/**
 * On cold start / refresh: hydrate Redux from GET /session (cookie).
 * Does not run again on in-app navigation.
 */
const AuthBootstrap = ({ children }) => {
  const dispatch = useDispatch();
  const authStatus = useSelector((state) => state.AuthenticationData.authStatus);
  const isSignedIn = useSelector((state) => state.AuthenticationData.isSignedIn);
  const [ready, setReady] = useState(authStatus !== "loading");

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      // Already signed in this tab (e.g. just logged in) — skip refetch.
      if (isSignedIn && authStatus === "authenticated") {
        setReady(true);
        return;
      }

      try {
        const res = await fetchSession();
        console.log("res", res);
        if (cancelled) return;

        const user = normalizeAuthUser(res);
        if (!user?.username && !user?.userId) {
          dispatch({ type: cnt.AUTH_STATUS, payload: "anonymous" });
        } else {
          if (user?.licensingConfig) {
            BOM.InitializeModuleLicensing(user.licensingConfig);
          }
          dispatch({ type: cnt.SIGN_IN, payload: user });
        }
      } catch (error) {
        if (cancelled) return;
        dispatch({ type: cnt.AUTH_STATUS, payload: "anonymous" });
      } finally {
        if (!cancelled) setReady(true);
      }
    };

    bootstrap();
    return () => {
      cancelled = true;
    };
    // Run once on mount (refresh / cold start).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!ready) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin size="large" tip="Loading session..." />
      </div>
    );
  }

  return children;
};

export default AuthBootstrap;
